import React from 'react';
import { isAptEnabled } from '../../../helpers/auth';

const HIDE_BACK = { 'hide-back': true };
const HIDE_BACK_PATHS = [
  '/confirmation',
  '/confirmation/xfinityStore',
  /\/confirmation\/[^/]+$/,
];
// Define paths where full navigation should be enabled
const FULLNAV_PATHS = [
  '/devices',
];

// Helper function to determine if full navigation should be shown
function showFullNav(pathname) {
  return FULLNAV_PATHS.some(path => pathname === path);
}

const canGoBack = (pathname, historyLength) => (
  historyLength > 1
  && !HIDE_BACK_PATHS.some(endPath => (
    endPath.test
      ? endPath.test(pathname)
      : pathname.endsWith(endPath)
  ))
);

// Renders the Polaris global header; returns null when APT is disabled
// to hide the top bar and account selector, falling back to the in-app account selection
// Exception: the /devices page always renders the Polaris header, APT flag notwithstanding.
const PolarisHeader = () => {
  const { pathname } = window.location;
  const { length: historyLength } = window.history;
  const isDevicesPage = showFullNav(pathname);
  if (!isAptEnabled() && !isDevicesPage) return null;

  return (
    <xc-header
      client-id="myAccountWeb"
      {...(isDevicesPage ? {} : { flownav: 'true' })}
      auto-auth="true"
      enable-account-selector="1"
      {...(!canGoBack(pathname, historyLength) ? HIDE_BACK : {})}
    />
  );
};

export default PolarisHeader;
